import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import logo from "../../src/images/nav/logot.png";
import profile from "../../src/images/profile.png";
import { logout } from "../redux/authSlice";

const Navbar = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const [isScrolled, setIsScrolled] = useState(false);
  const [isLogoutModalOpen, setLogoutModalOpen] = useState(false);
  const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);

  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  const user = useSelector((state) => state.auth.user);
  const [isProfileOpen, setIsProfileOpen] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  const [showLogoutMessage, setShowLogoutMessage] = useState(false);

  const [isLoginDropdownOpen, setLoginDropdownOpen] = useState(false);
  const [isSignupDropdownOpen, setSignupDropdownOpen] = useState(false);

  const [isDetailsVisible, setIsDetailsVisible] = useState(false); // New state

  const handleLogout = () => setLogoutModalOpen(true);

  const confirmLogout = () => {
    localStorage.removeItem("authToken");
    localStorage.removeItem("authUser");
    localStorage.removeItem("authExpiration");
    dispatch(logout());
    setLogoutModalOpen(false);
    navigate("/");
  };

  const cancelLogout = () => setLogoutModalOpen(false);

  const toggleLoginDropdown = () => {
    setLoginDropdownOpen((prev) => !prev);
    setSignupDropdownOpen(false);
  };

  const toggleSignupDropdown = () => {
    setSignupDropdownOpen((prev) => !prev);
    setLoginDropdownOpen(false);
  };

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 0);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleScrollToAbout = () => {
    if (location.pathname === "/") {
      const aboutSection = document.getElementById("about-us");
      if (aboutSection) {
        aboutSection.scrollIntoView({ behavior: "smooth" });
      }
    } else {
      // Pass state to indicate the About section should be scrolled to
      navigate("/", { state: { scrollToAbout: true } });
    }
  };

  const handleScrollToContact = () => {
    if (location.pathname === "/") {
      const aboutSection = document.getElementById("contact");
      if (aboutSection) {
        aboutSection.scrollIntoView({ behavior: "smooth" });
      }
    } else {
      // Pass state to indicate the About section should be scrolled to
      navigate("/", { state: { scrollToAbout: true } });
    }
  };

  const handleToggleProfile = () => {
    setIsProfileOpen(!isProfileOpen);
    setIsDetailsVisible(!isDetailsVisible); // Toggle details visibility
    setShowLogoutMessage(false); // Reset logout message
  };

  const handleNavigate = (path) => {
    if (!isAuthenticated) {
      // If not authenticated, redirect to login page
      navigate("/login");
    } else {
      // If authenticated, proceed with the regular navigation
      navigate(path);
    }
  };

  const [isLogoutVisible, setIsLogoutVisible] = useState(false);

  const handleDivClick = () => {
    setIsLogoutVisible(!isLogoutVisible); // Toggle visibility when the div is clicked
  };

  return (
    <>
     <nav
  className={`flex items-center justify-between w-full z-50 fixed top-0 transition-all duration-500 ease-in-out font-clash
    ${
      isScrolled
        ? "h-16 p-2 bg-opacity-95 bg-[#1F1F1F] lg:bg-opacity-20 lg:backdrop-blur-sm"
        : "lg:h-24 p-4 h-[80px]   bg-[#1F1F1F] lg:bg-[#71892986] lg:backdrop-blur-sm"
    }`}
>
        {/* Logo Section */}
        <div
          className={`flex items-center ml-[-20px] bg-[#1F1F1F] transition-all duration-500 ease-in-out ${
            isScrolled ? "h-16" : "lg:h-24 h-[80px]"
          }`}
        >
          <img src={logo} alt="imagelogo" className="object-contain h-full" />
        </div>

        {/* Hamburger Icon for Mobile */}
        <div className="flex items-center lg:hidden">
          <div
            id="nav-icon4"
            className={`cursor-pointer ${isMobileMenuOpen ? "open" : ""}`}
            onClick={() => setMobileMenuOpen(!isMobileMenuOpen)}
            style={{
              width: "40px",
              height: "30px",
              position: "relative",
              margin: "20px auto",
              transform: "rotate(0deg)",
              transition: "0.5s ease-in-out",
            }}
          >
            {/* Top Line */}
            <span
              style={{
                display: "block",
                position: "absolute",
                height: "2px",
                width: "100%",
                background: "#F0FFC5",
                borderRadius: "2px",
                left: 0,
                top: 0,
                transformOrigin: "center",
                transition: "0.25s ease-in-out",
                ...(isMobileMenuOpen && {
                  transform: "rotate(45deg)",
                  top: "12px", // Move to the center for X
                }),
              }}
            ></span>

            {/* Middle Line */}
            <span
              style={{
                display: "block",
                position: "absolute",
                height: "2px",
                width: "100%",
                background: "#F0FFC5",
                borderRadius: "2px",
                left: 0,
                top: "12px",
                transformOrigin: "center",
                transition: "0.25s ease-in-out",
                ...(isMobileMenuOpen && {
                  transform: "scale(0)", // Disappear when forming the X
                }),
              }}
            ></span>

            {/* Bottom Line */}
            <span
              style={{
                display: "block",
                position: "absolute",
                height: "2px",
                width: "100%",
                background: "#F0FFC5",
                borderRadius: "2px",
                left: 0,
                top: "24px",
                transformOrigin: "center",
                transition: "0.25s ease-in-out",
                ...(isMobileMenuOpen && {
                  transform: "rotate(-45deg)",
                  top: "12px", // Move to the center for X
                }),
              }}
            ></span>
          </div>
        </div>

        {/* Desktop Links Section */}
        <div className="hidden lg:flex items-center pt-8 justify-around space-x-16 text-white">
          {!isAuthenticated ? (
            <>
              <Link to="/" className="mx-2">
                Home
              </Link>
              <button onClick={handleScrollToAbout} className="mx-2">
                About Us
              </button>
              <button
                onClick={() => handleNavigate("/service")}
                className="mx-2"
              >
                Services
              </button>
              <button
                onClick={handleScrollToContact}
                className="mx-2"
              >
                Contact
              </button>
              <button
                onClick={() => handleNavigate("/progress")}
                className="mx-2"
              >
                Track Your Progress
              </button>
            </>
          ) : user?.role === "admin" ? (
            <div className="hidden relative text-left">
              <button
                onClick={() => setIsOpen(!isOpen)}
                className="px-4 py-2 bg-[#1F1F1F] text-white rounded-md"
              >
                Admin Menu
              </button>

              {isOpen && (
                <div className="absolute right-0 z-10 mt-2 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5">
                  <div className="py-1 text-gray-700">
                    <Link to="/assign-tasks" className="block px-4 py-2 hover:bg-gray-100">
                      Assign Tasks
                    </Link>
                    <Link to="/manage-users" className="block px-4 py-2 hover:bg-gray-100">
                      Manage Users
                    </Link>
                    <Link to="/manage-technicians" className="block px-4 py-2 hover:bg-gray-100">
                      Manage Technicians
                    </Link>
                    <Link to="/pdi-reports" className="block px-4 py-2 hover:bg-gray-100">
                      PDI Reports
                    </Link>
                    <Link to="/landing-page" className="block px-4 py-2 hover:bg-gray-100">
                      Landing Page Editor
                    </Link>
                    <Link to="/dropdown" className="block px-4 py-2 hover:bg-gray-100">
                      Dropdown
                    </Link>
                  </div>
                </div>
              )}
            </div>
          ) : user?.role === "technician" ? (
            <>
              <Link to="/technician-dashboard" className="mx-2">
                Technician Dashboard
              </Link>
              <Link to="/my-jobs" className="mx-2">
                My Jobs
              </Link>
              <Link to="/contact" className="mx-2">
                Contact
              </Link>
            </>
          ) : (
            <>
              <Link to="/" className="mx-2">
                Home
              </Link>
              <button onClick={handleScrollToAbout} className="mx-2">
                About Us
              </button>
              <button
                onClick={() => handleNavigate("/service")}
                className="mx-2"
              >
                Services
              </button>
              <button
                onClick={handleScrollToContact}
                className="mx-2"
              >
                Contact
              </button>
              <button
                onClick={() => handleNavigate("/progress")}
                className="mx-2"
              >
                Track Your Progress
              </button>
            </>
          )}
        </div>

        {/* Mobile Menu Dropdown */}
        {isMobileMenuOpen && (
          <div
            className={`absolute w-full bg-[#1F1F1F] text-white flex flex-col items-start space-y-4 py-4 px-6 transition-all duration-300 left-0 
            ${isScrolled ? "top-16" : "top-[80px] lg:top-24"}`}
          >
            {!isAuthenticated ? (
              <>
              <Link
                to="/"
                className="mx-2"
                onClick={() => {
                  setMobileMenuOpen(false);
                }}
              >
                Home
              </Link>
              <Link
                to="/"
                className="mx-2"
                onClick={() => {
                  setMobileMenuOpen(false);
                  handleScrollToAbout();
                }}
              >
                About Us
              </Link>
              <Link
                to="/service"
                className="mx-2"
                onClick={() => {
                  setMobileMenuOpen(false);
                  handleNavigate("/service");
                }}
              >
                Services
              </Link>
              <Link
                to="/"
                className="mx-2"
                onClick={() => {
                  setMobileMenuOpen(false);
                  handleScrollToContact();
                }}
              >
                Contact
              </Link>
              <Link
                to="/progress"
                className="mx-2"
                onClick={() => {
                  setMobileMenuOpen(false);
                  handleNavigate("/progress");
                }}
              >
                Track Your Progress
              </Link>

                {/* Login & Signup Buttons */}
                <button
                  onClick={() => navigate('/login')}
                  // onClick={toggleLoginDropdown}
                  className="mx-2 px-10 py-2 rounded-full border bg-black bg-opacity-50 border-[#718929] text-[#F0FFC5] hover:bg-opacity-70 transition-all duration-300"
                >
                  Login
                </button>
                {/* {isLoginDropdownOpen && (
                  <div className="bg-white text-black shadow-lg rounded mt-2">
                    <Link
                      to="/login"
                      className="block px-4 py-2"
                      onClick={() => setMobileMenuOpen(false)}
                    >
                      Normal Login
                    </Link>
                    <Link
                      to="/login/technician"
                      className="block px-4 py-2"
                      onClick={() => setMobileMenuOpen(false)}
                    >
                      Technician Login
                    </Link>
                  </div>
                )} */}

                <button
                  onClick={() => navigate('/signup')}
                  // onClick={toggleSignupDropdown}
                  className="mx-2 px-8 py-2 rounded-full border bg-black bg-opacity-50 border-[#718929] text-[#F0FFC5] hover:bg-opacity-70 transition-all duration-300"
                >
                  Sign Up
                </button>
                {/* {isSignupDropdownOpen && (
                  <div className="bg-white text-black shadow-lg rounded mt-2">
                    <Link
                      to="/signup"
                      className="block px-8 py-2"
                      onClick={() => setMobileMenuOpen(false)}
                    >
                      Normal Sign Up
                    </Link>
                    <Link
                      to="/signup/technician"
                      className="block px-4 py-2"
                      onClick={() => setMobileMenuOpen(false)}
                    >
                      Technician Sign Up
                    </Link>
                  </div>
                )} */}
              </>
            ) : user?.role === "admin" ? (
              <>
                <Link
                  to="/admin"
                  className="mx-2"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  Admin Dashboard
                </Link>              
                <Link
                  to="/assign-tasks"
                  className="mx-2"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  Assign Tasks
                </Link>
                <Link
                  to="/manage-users"
                  className="mx-2"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  Manage Users
                </Link>
                <Link
                  to="/manage-technicians"
                  className="mx-2"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  Manage Technicians
                </Link>
                <Link
                  to="/pdi-reports"
                  className="mx-2"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  PDI Reports
                </Link>
                <Link 
                  to="/landing-page"
                  className="mx-2"
                  onClick={() => setMobileMenuOpen(false)}                
                >
                  Landing Page Editor
                </Link>
                <Link 
                  to="/dropdown"
                  className="mx-2"
                  onClick={() => setMobileMenuOpen(false)}                
                >
                  Dropdown
                </Link>
              </>
            ) : user?.role === "technician" ? (
              <>
                <Link
                  to="/technician-dashboard"
                  className="mx-2"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  Technician Dashboard
                </Link>
                <Link
                  to="/my-jobs"
                  className="mx-2"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  My Jobs
                </Link>
                <Link
                  to="/"
                  className="mx-2"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  Contact
                </Link>
              </>
            ) : (
              <>
              <Link
                to="/"
                className="mx-2"
                onClick={() => {
                  setMobileMenuOpen(false);
                }}
              >
                Home
              </Link>
              <Link
                to="/"
                className="mx-2"
                onClick={() => {
                  setMobileMenuOpen(false);
                  handleScrollToAbout();
                }}
              >
                About Us
              </Link>
              <Link
                to="/service"
                className="mx-2"
                onClick={() => {
                  setMobileMenuOpen(false);
                  handleNavigate("/service");
                }}
              >
                Services
              </Link>
              <Link
                to="/"
                className="mx-2"
                onClick={() => {
                  setMobileMenuOpen(false);
                  handleScrollToContact();
                }}
              >
                Contact
              </Link>
              <Link
                to="/progress"
                className="mx-2"
                onClick={() => {
                  setMobileMenuOpen(false);
                  handleNavigate("/progress");
                }}
              >
                Track Your Progress
              </Link>
                <button
                  onClick={() => {
                    handleLogout();
                    setMobileMenuOpen(false);
                  }}
                  className="mx-2 px-4 py-2 rounded-full border bg-black bg-opacity-50 border-[#718929] text-[#F0FFC5] hover:bg-opacity-70 transition-all duration-300"
                >
                  Logout
                </button>
              </>
            )}
          </div>
        )}

        {/* Login/Logout and User Section */}
        <div className="relative lg:flex hidden">
          {!isAuthenticated ? (
            <>
              <button
                onClick={() => navigate('/login')}
                className="mr-4 px-10 py-1 rounded-full border bg-black bg-opacity-50 border-[#718929] text-[#F0FFC5] hover:bg-opacity-70 transition-all duration-300"
              >
                Login
              </button>
              {/* {isLoginDropdownOpen && (
                <div className="absolute bg-white text-black shadow-lg rounded mt-2">
                  <Link to="/login" className="block px-4 py-2">
                    Normal Login
                  </Link>
                  <Link to="/login/technician" className="block px-4 py-2">
                    Technician Login
                  </Link>
                </div>
              )} */}

              <button
                onClick={() => navigate('/signup')}
                className="mr-4 px-10 py-2 rounded-full border bg-black bg-opacity-50 border-[#718929] text-[#F0FFC5] hover:bg-opacity-70 transition-all duration-300"
              >
                Sign Up
              </button>
              {/* {isSignupDropdownOpen && (
                <div className="absolute bg-white text-black shadow-lg rounded mt-2">
                  <Link to="/signup" className="block px-4 py-2">
                    Normal Sign Up
                  </Link>
                  <Link to="/signup/technician" className="block px-4 py-2">
                    Technician Sign Up
                  </Link>
                </div>
              )} */}
            </>
          ) : (

            <div className="flex flex-row items-center justify-between gap-52">
              {user?.role === "admin" && (
             <div className="relative inline-block text-left">
              <button
                onClick={() => setIsOpen(!isOpen)}
                className="px-4 py-2 bg-[#1F1F1F] text-white rounded-md"
              >
                Admin Menu
              </button>

              {isOpen && (
                <div className="absolute right-0 z-10 mt-2 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5">
                  <div className="py-1 text-gray-700">
                    <Link to="/admin" className="block px-4 py-2 hover:bg-gray-100">
                      Admin Dashboard
                    </Link>                    
                    <Link to="/assign-tasks" className="block px-4 py-2 hover:bg-gray-100">
                      Assign Tasks
                    </Link>
                    <Link to="/manage-users" className="block px-4 py-2 hover:bg-gray-100">
                      Manage Users
                    </Link>
                    <Link to="/manage-technicians" className="block px-4 py-2 hover:bg-gray-100">
                      Manage Technicians
                    </Link>
                    <Link to="/pdi-reports" className="block px-4 py-2 hover:bg-gray-100">
                      PDI Reports
                    </Link>
                    <Link to="/landing-page" className="block px-4 py-2 hover:bg-gray-100">
                      Landing Page Editor
                    </Link>
                    <Link to="/dropdown" className="block px-4 py-2 hover:bg-gray-100">
                      Dropdown
                    </Link>
                  </div>
                </div>
              )}
            </div>
            )}
            
            <div className="relative">
            {/* Sticky Profile */}
            <div
              className={`fixed ${isScrolled ? "top-2" : "top-2"} right-10 flex items-start space-x-2 cursor-pointer bg-[#1F1F1F] transition-all ${
                isScrolled ? "p-2 rounded-full" : "p-2 px-4 rounded-2xl"
              }`}
              onClick={() => {
                handleToggleProfile();
                handleDivClick();
              }}
            >
              <img
                src={user?.image || profile}
                alt="Profile"
                className={`${
                  isScrolled ? "w-10 h-10" : "w-10 h-10"
                } rounded-full object-cover transition-all`}
              />
              {!isScrolled && (
                <div className="text-white font-medium transition-opacity duration-500 ease-in-out">
                  <div className="pl-3">
                    <p className="font-bold text-[14px]">{user.firstname} {user.lastname}</p>
                  </div>
                  <div
                  className={`${
                    isLogoutVisible ? "opacity-100 max-h-screen" : "opacity-0 max-h-0"
                  } transition-all duration-1000 ease-in-out overflow-hidden`}
                >
                  {isLogoutVisible && (
                    <>
                      <hr
                        className="mt-2 ml-3"
                        style={{
                          height: "1px",
                          width: "80%", // Adjust the percentage to control the length of the line
                          backgroundImage:
                            "linear-gradient(to right, rgba(240, 255, 197, 1) 0%, rgba(240, 255, 197, 0.2) 100%)",
                        }}
                      />
                      <button
                        onClick={handleLogout}
                        className="w-[100px] py-1 mt-0 text-[#F0FFC5] pr-3"
                      >
                        Sign out
                      </button>
                    </>
                  )}
                </div>

                </div>
              )}
            </div>
            </div>
          
            {/* Dropdown Profile Menu with Smooth Transition */}
            {isScrolled && isProfileOpen &&  (
              <div
                className="absolute top-8 right-5 bg-opacity-90 rounded-lg shadow-lg p-4 space-y-2 text-white w-40 transition-all transform opacity-0"
                style={{ opacity: isProfileOpen ? 1 : 0, transform: isProfileOpen ? "translateY(0)" : "translateY(-10px)" }}
              >
                <div className="relative">
                  <div className="absolute top-[-10px] right-[10px] w-4 h-4 bg-black rotate-45 transform origin-top-left border-t border-l border-[#F0FFC5]"></div>
                  <button
                    onClick={handleLogout}
                    className="w-full py-2 px-4 bg-black text-[#F0FFC5] rounded-lg hover:bg-opacity-70 transition-all duration-300 border-2 border-[#F0FFC5] text-center"
                  >
                    Sign out
                  </button>
                </div>
              </div>
            )}
          
            {/* Logout Message with Smooth Transition */}
            {showLogoutMessage && (
              <div
                className="fixed bottom-4 left-1/2 transform -translate-x-1/2 bg-black text-white px-4 py-2 rounded-lg shadow-lg transition-all opacity-0"
                style={{
                  opacity: showLogoutMessage ? 1 : 0,
                  transform: showLogoutMessage ? "translateY(0)" : "translateY(10px)",
                }}
              >
                Signed out successfully!
              </div>
            )}
          </div>
          
          )}
        </div>
      </nav>

      {/* Logout Modal */}
      {isLogoutModalOpen && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-10">
          <div className="bg-white p-8 rounded-lg shadow-lg">
            <p>Are you sure you want to log out?</p>
            <div className="flex justify-end space-x-4 mt-4">
              <button
                onClick={confirmLogout}
                className="bg-red-500 text-white px-4 py-2 rounded"
              >
                Yes
              </button>
              <button
                onClick={cancelLogout}
                className="bg-gray-300 px-4 py-2 rounded"
              >
                No
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Navbar;
